<template>
  <div>
    <div class="container mini">
      <div class="bg-gray rounded-md shadow my-6">
        <div class="flex justify-between items-start">
          <div class="p-6 md:px-9 md:pt-9 pb-6">
            <Logo class="w-48 md:w-auto" />
          </div>
          <LangSwitcher />
        </div>
        <div class="pb-9 px-6 md:px-9 border-b border-purple-gray">
          <p class="leading-snug">
            {{ $t('auth.text') }}
          </p>
        </div>
        <div class="pb-5 px-6 md:px-9 text-center">
          <h2 class="font-semibold text-black-display mt-6 mb-3 text-2xl text-center ornament">
            {{ $t('auth.confirmEmailHeader') }}
          </h2>
          <p class="mt-10 text-center">
            {{ $t('auth.confirmEmail') }}
          </p>
          <router-link
            :to="{name: 'LOGIN'}"
            class="mt-10 back-to-login"
          >
            {{ $t('auth.backToLogin') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LangSwitcher from '@/components/LangSwitcher';
import Logo from '@/assets/img/logo.svg';

export default {
  name: 'RegisterConfirmation',
  components: {
    LangSwitcher,
    Logo,
  },
};
</script>
<style lang="scss" scoped>
  .spinner {
    position: absolute;
    right: 36px;
    top: 18px;
  }
  input {
    transition: all .5s ease;
  }
  button {
    position: relative;
    transition: all .5s ease;
    padding-right: 36px;
    &.loading {
      padding-right: 58px;
    }
  }
  .back-to-login {
    color: #51338B;
    font-weight: bold;
    display: block;
  }
</style>
